import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Controller, useForm } from "react-hook-form"
import {
	TextField,
	Grid,
	Container,
	FormControl,
	Card,
	CardContent
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles"
import usuarioService from "../../services/usuarioService"
import { usuarioPerfilFazendaEsquema } from "./usuarioPerfilFazenda.validate"
import { yupResolver } from "@hookform/resolvers/yup"
import Page from "../../components/Page"
import Titulo from "../../components/Titulo"
import Autocomplete from "@material-ui/lab/Autocomplete"
import FooterBottons from "../../components/FooterBottons/FooterBottons"
import perfilService from "../../services/PerfilService"
import ToastHelper from '../../utils/toastHelper'
import fazendaService from "../../services/fazendaService"
import usuarioPerfilFazendaService from "../../services/usuarioPerfilFazendaService"
import { validatePermission } from "../../permissoes/permissionHelper"
import { PERMISSAO } from "../../permissoes/permissoes"
import { connect } from "react-redux"
import { Store } from "../../store"
import watch from "redux-watch"

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3),
	},
	margin: {
		margin: theme.spacing(1),
	},
	card: {
		marginTop: '15px',
	},
	formControl: {
		margin: theme.spacing(2),
		paddingRight: "15px",
		minWidth: '100%',
	},
	errors: {
		color: 'red',
	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justify: 'center',
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: '2px solid #000',
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
	},
	boxLoading: {
		paddingLeft: '45%',
	},

}));

function CadastroUsuarioPerfilFazenda(props) {
	const classes = useStyles();
	let history = useHistory();

	const {
		match: { params },
	} = props;


	const {
		handleSubmit,
		control,
		setValue,
		formState: { errors },
	} = useForm({
		defaultValues: {
			editar: false,
			usuario: null,
			perfil: null,
			clientes: [],
		},
		resolver: yupResolver(usuarioPerfilFazendaEsquema),
	});

	const [titulo, setTitulo] = useState("Cadastro Usuário Perfil Cliente")
	const [visualizar, setVisualizar] = useState(false)
	const [editar, setEditar] = useState(false)

	const [opcoesCliente, setOpcoesCliente] = useState([])
	const [opcoesPerfil, setOpcoesPerfil] = useState([])
	const [opcoesUsuario, setOpcoesUsuario] = useState([])

	const buscarUsuarioPerfilFazenda = async () => {
		if (params.id) {
			if (params.modo === 'visualizar') {
				if (!validatePermission(PERMISSAO.MODULO_USUARIO_PERFIL_FAZENDA_LEITURA, props.permissoes)) {
					history.push("/")
				}
				setVisualizar(true)
				setTitulo('Visualizar Usuário Perfil Cliente')
				setEditar(false)
				setValue('editar', false)
			}
			if (params.modo === 'editar') {
				if (!validatePermission(PERMISSAO.MODULO_USUARIO_PERFIL_FAZENDA_ATUALIZAR, props.permissoes)) {
					history.push("/")
				}
				setEditar(true)
				setValue('editar', true)
				setTitulo('Editar Usuário Perfil Cliente')
				setVisualizar(false)
			}
			usuarioPerfilFazendaService.buscarUsuarioPerfilCliente(params.id).then((result) => {
				var usuarioModuloCliente = result.data
				setValue('usuario', usuarioModuloCliente.usuario)
				setValue('perfil', { id: usuarioModuloCliente.perfil.id, nome: usuarioModuloCliente.perfil.nome })
				if (params.modo === 'visualizar') {
					setValue('clientes', [{ id: usuarioModuloCliente.cliente.id, nomeRazao: usuarioModuloCliente.cliente.nomeRazao }])
				}
				if (params.modo === 'editar') {
					setValue('clientes', { id: usuarioModuloCliente.cliente.id, nomeRazao: usuarioModuloCliente.cliente.nomeRazao })
				}
			}).catch((error) => {
				ToastHelper.error("Erro ao buscar Usuário Modulo Cliente")
			});
		}
	};

	const onSubmit = async (dados) => {
		if (params.id) {
			var usuarioModuloFazenda = {
				id: params.id,
				usuarioId: dados.usuario.id,
				perfilId: dados.perfil.id,
				clienteId: dados.clientes.id
			}

			usuarioPerfilFazendaService.atualizar(usuarioModuloFazenda).then((result) => {
				var listaUsuarioModuloCliente = result.data

				if (listaUsuarioModuloCliente.length === 0) {
					ToastHelper.success('Usuário Perfil Cliente atualizado com sucesso!')
					history.goBack()
				}

				listaUsuarioModuloCliente.forEach(usuarioPerfilCliente => {
					ToastHelper.error("Já existe o cadastro do perfil " + usuarioPerfilCliente.perfil + " para o cliente " + usuarioPerfilCliente.cliente)
				});

			})
				.catch((error) => {
					ToastHelper.error(error.response.data)
				});
		}
		else {
			var usuarioPerfilFazendaCadastro = {
				usuarioId: dados.usuario.id,
				perfilId: dados.perfil.id,
				clientes: dados.clientes.map(a => a.id)
			}

			usuarioPerfilFazendaService.cadastro(usuarioPerfilFazendaCadastro).then((result) => {
				var listaUsuarioPerfilCliente = result.data

				if (listaUsuarioPerfilCliente.length === 0) {
					ToastHelper.success('Usuário Perfil Cliente cadastrado com sucesso!')
					history.goBack()
				}

				listaUsuarioPerfilCliente.forEach(usuarioModuloCliente => {
					ToastHelper.error("Já existe o cadastro do perfil " + usuarioModuloCliente.perfil + " para o cliente " + usuarioModuloCliente.cliente)
				});

			})
				.catch((error) => {
					ToastHelper.error(error.response.data)
				});
		}

	};

	useEffect(() => {
		async function init() {
			const w = watch(Store.getState, "permissao.permissoes");
			Store.subscribe(
				w((newVal, oldVal, objectPath) => {
					if (!validatePermission(PERMISSAO.MODULO_USUARIO_MODULO_FAZENDA_CRIAR, newVal)) {
						history.push("/")
					}
				})
			)
			buscarPerfis()
			buscarFazendas()

			if (params.id) {
				if (params.modo === 'editar') {
					Store.subscribe(
						w((newVal, oldVal, objectPath) => {
							if (!validatePermission(PERMISSAO.MODULO_USUARIO_MODULO_FAZENDA_ATUALIZAR, newVal)) {
								history.push("/")
							}
						})
					)
				}

				if (params.modo === 'visualizar') {
					Store.subscribe(
						w((newVal, oldVal, objectPath) => {
							if (!validatePermission(PERMISSAO.MODULO_USUARIO_MODULO_FAZENDA_LEITURA, newVal)) {
								history.push("/")
							}
						})
					)
				}

				buscarUsuarioPerfilFazenda()
			}
		}
		init();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const buscarPerfis = async () => {
		await perfilService.buscarTodosPerfis().then((result) => {
			var perfis = result.data
			setOpcoesPerfil(perfis)
			if (perfis.length === 1) {
				setValue("perfil", perfis[0])
			}
		}).catch((error) => {
			ToastHelper.error('Erro ao buscar perfis')
		});
	}

	const buscarFazendas = async () => {
		await fazendaService.getAll().then((result) => {
			const fazendas = result.data
			setOpcoesCliente(fazendas)
			if (fazendas.length === 1) {
				setValue("clientes", [{ id: fazendas[0].id, nomeRazao: fazendas[0].nomeRazao }])
			}
		})
			.finally(() => {
				if (props.onLoaded) props.onLoaded()
			});
	};

	const buscarUsuarios = async (event, value) => {
		if (value.length >= 3) {
			usuarioService.buscarUsuarios(value).then((result) => {
				var usuarios = result.data
				setOpcoesUsuario(usuarios)
			})
				.catch((error) => {
					ToastHelper.error('Erro ao tentar buscar usuários')
				});
		}
		if (value === '') {
			setValue('usuario', null)
			setOpcoesUsuario([])
		}
	}

	return (
		<Page className={classes.root} title='Usuário Perfil Cliente'>
			<Container maxWidth={"xl"}>
				<Titulo titulo={titulo} />
				<form
					key={1}
					className={classes.form}
					onSubmit={handleSubmit(onSubmit)}
					id='usuarioModuloCliente'
				>
					<Card className={classes.card}>
						<CardContent>
							<Grid container item xs={12} display='flex'>
								<Grid container item xs={6} display='flex'>
									<FormControl className={classes.formControl}>
										<Controller
											control={control}
											id='usuario'
											name='usuario'
											render={({ field }) => (
												<Autocomplete
													{...field}
													freeSolo
													options={
														opcoesUsuario
													}
													disabled={visualizar || editar}
													getOptionLabel={(option) => option.usuario || ""}
													onChange={(_, data) => {
														field.onChange(data)
													}}
													size="small"
													getOptionSelected={(
														option,
														value
													) =>
														option?.id === value?.id
													}
													value={field.value}
													onInputChange={(event, value) => {
														buscarUsuarios(event, value)

													}}
													renderInput={(params) => (
														<TextField
															{...params}
															variant="standard"
															label="Usuário*"
															placeholder="Selecione"
															InputLabelProps={{
																shrink: true,
															}}
															disabled={editar || visualizar}
														/>
													)}
												/>
											)}
										/>
										<p className={classes.errors}>
											{errors.usuario ? errors.usuario.message : ""}
										</p>
									</FormControl>
								</Grid>
								<Grid container item xs={6} display='flex'>
									<FormControl className={classes.formControl}>
										<Controller
											control={control}
											id='perfil'
											name='perfil'
											render={({ field }) => (
												<Autocomplete
													{...field}
													options={
														opcoesPerfil
													}
													disabled={visualizar}
													getOptionLabel={(option) => option.nome || ""}
													onChange={(_, data) => {
														field.onChange(data)
													}}
													size="small"
													getOptionSelected={(
														option,
														value
													) =>
														option?.id === value?.id
													}
													value={field.value}
													renderInput={(params) => (
														<TextField
															{...params}
															variant="standard"
															label="Perfil*"
															placeholder="Selecione"
															InputLabelProps={{
																shrink: true,
															}}
														/>
													)}
												/>
											)}
										/>
										<p className={classes.errors}>
											{errors.perfil ? errors.perfil.message : ""}
										</p>
									</FormControl>
								</Grid>
							</Grid>
							<Grid container item xs={12} display='flex'>
								<Grid container item xs={12} display='flex'>
									<FormControl className={classes.formControl}>
										<Controller
											control={control}
											id='clientes'
											name='clientes'
											disabled={visualizar}
											render={({ field }) => (
												<Autocomplete
													{...field}
													options={
														opcoesCliente
													}
													disabled={visualizar || editar}
													getOptionLabel={(option) => option.nomeRazao || ""}
													onChange={(_, data) => {
														field.onChange(data)
													}}
													size="small"
													getOptionSelected={(
														option,
														value
													) =>
														option?.id === value?.id
													}
													value={field.value}
													multiple={!editar}
													renderInput={(params) => (
														<TextField
															{...params}
															variant="standard"
															label="Clientes*"
															placeholder="Selecione"
															InputLabelProps={{
																shrink: true,
															}}
														/>
													)}
												/>
											)}
										/>
										<p className={classes.errors}>
											{errors.clientes ? errors.clientes.message : ""}
										</p>
									</FormControl>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
					<FooterBottons desabilitaSubmit={visualizar} />
				</form>
			</Container>
		</Page>
	);
}

const mapStateToProps = state => {
	return {
		permissoes: state.permissao.permissoes
	};
};

export default connect(mapStateToProps)(CadastroUsuarioPerfilFazenda);
